import { DOCUMENT_NAMES } from "../../../constants/rfp";

/**
 * An entry of `rfp.uploadedFiles` as the reducer stores it. The context types
 * declare these as `RfpDocument`, which they are not, so entries are checked
 * rather than trusted.
 */
interface UploadedFileEntry {
  readonly documentTypes: Readonly<Record<string, readonly string[]>>;
  readonly file: { readonly id: number };
}

const isRecord = (value: unknown): value is Readonly<Record<string, unknown>> =>
  typeof value === "object" && value !== null;

const isUploadedFileEntry = (entry: unknown): entry is UploadedFileEntry =>
  isRecord(entry) &&
  isRecord(entry.documentTypes) &&
  isRecord(entry.file) &&
  typeof entry.file.id === "number";

/**
 * The census file the RFP is quoted on: the newest one uploaded, as bp-api
 * reads it at submission. Undefined when none has been uploaded.
 */
export const newestCensusDocumentId = (
  uploadedFiles: readonly unknown[],
): number | undefined => {
  const ids = uploadedFiles
    .filter(isUploadedFileEntry)
    .filter(({ documentTypes }) =>
      Object.hasOwn(documentTypes, DOCUMENT_NAMES.CENSUS),
    )
    .map(({ file }) => file.id);

  return ids.length > 0 ? Math.max(...ids) : undefined;
};
